import { useMemo, useState } from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";

export const SETTORI = [
  "Agricoltura", "Ortofrutta / Ingrosso alimentare", "Industria alimentare", "Metalmeccanica",
  "Edilizia e costruzioni", "Logistica e trasporti", "Commercio all'ingrosso", "Commercio al dettaglio / GDO",
  "Automotive", "Chimica e plastica", "Tessile e abbigliamento", "Legno e arredamento",
  "Turismo e ricettività", "Ristorazione", "Sanità e case di cura", "Servizi e uffici",
  "Immobiliare", "Energia e utilities", "Istruzione e formazione", "Pubblica amministrazione",
];

export const FONTI = [
  "Passaparola", "Fiera / Evento", "Sito web", "Social (FB/IG/LinkedIn)",
  "Campagna email / Newsletter", "Telefonata a freddo", "Referral cliente esistente",
  "Agente / Rete vendita", "Pubblicità / Advertising", "Portale / Directory",
];

export default function FlagPicker({ options, value, onChange, label, testid = "flag" }) {
  const initial = useMemo(() => {
    const toks = (value || "").split(",").map((t) => t.trim()).filter(Boolean);
    return { known: toks.filter((t) => options.includes(t)), altro: toks.filter((t) => !options.includes(t)).join(", ") };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [known, setKnown] = useState(new Set(initial.known));
  const [altroOn, setAltroOn] = useState(initial.altro.length > 0);
  const [altro, setAltro] = useState(initial.altro);

  const emit = (k, on, a) => {
    const parts = options.filter((x) => k.has(x));
    if (on && (a || "").trim()) parts.push(a.trim());
    onChange(parts.join(", "));
  };
  const toggle = (s) => { const k = new Set(known); k.has(s) ? k.delete(s) : k.add(s); setKnown(k); emit(k, altroOn, altro); };
  const toggleAltro = (v) => { setAltroOn(!!v); emit(known, !!v, altro); };
  const changeAltro = (v) => { setAltro(v); emit(known, altroOn, v); };

  return (
    <div className="space-y-2 sm:col-span-2">
      <Label className="text-xs">{label} <span className="font-normal text-muted-foreground">(seleziona uno o più)</span></Label>
      <div className="grid grid-cols-1 gap-x-4 gap-y-1.5 rounded-md border border-border p-3 sm:grid-cols-2" data-testid={`${testid}-grid`}>
        {options.map((s, i) => (
          <label key={s} className="flex cursor-pointer items-center gap-2 text-xs">
            <Checkbox checked={known.has(s)} onCheckedChange={() => toggle(s)} data-testid={`${testid}-${i}`} />
            <span>{s}</span>
          </label>
        ))}
        <label className="flex cursor-pointer items-center gap-2 text-xs font-semibold">
          <Checkbox checked={altroOn} onCheckedChange={toggleAltro} data-testid={`${testid}-altro-flag`} />
          <span>Altro</span>
        </label>
      </div>
      {altroOn && (
        <Input value={altro} onChange={(e) => changeAltro(e.target.value)} placeholder="Specifica…" data-testid={`${testid}-altro`} />
      )}
    </div>
  );
}
